"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserIdType = exports.getUserIdTypeNumber = void 0;
var driftTypes_1 = require("@driftt/app-config/dist/utils/driftTypes");
Object.defineProperty(exports, "UserIdType", {
  enumerable: true,
  get: function get() {
    return driftTypes_1.UserTypeIF;
  }
});
var getUserIdTypeNumber = function getUserIdTypeNumber(userIdType) {
  switch (userIdType) {
    case driftTypes_1.UserTypeIF.USER:
      {
        return 1;
      }
    case driftTypes_1.UserTypeIF.END_USER:
      {
        return 2;
      }
    case driftTypes_1.UserTypeIF.NONE:
      {
        return 3;
      }
    case driftTypes_1.UserTypeIF.LEAD:
      {
        return 4;
      }
  }
};
exports.getUserIdTypeNumber = getUserIdTypeNumber;